import { CourseTypeEnum } from "../enums";
import { $host } from "./index";

export type PostCourseAnswerArgs = {
  courseId: number;
  answers: Record<number, string | string[]>;
  user: any;
};

export default class TaskService {
  static async getCourse(id: string, courseType: CourseTypeEnum) {
    let suffix = "";
    switch (courseType) {
      case CourseTypeEnum.EXAM:
        suffix = "exam/";
        break;
      case CourseTypeEnum.THEME:
        suffix = "theme/";
        break;
    }

    return await $host.get("course/" + suffix + id, {
      params: { user: JSON.parse(localStorage.getItem("auth")!).id },
    });
  }

  static async postAnswersToCourse(args: PostCourseAnswerArgs) {
    return await $host.post("course/" + args.courseId, args);
  }

  static async getTask(id: number) {
    const res = await $host.get("task/" + id.toString());
    return res;
  }
}
